export default __webpack_public_path__ + "static/media/34_Kukacka_obecna_PELZ_Roche_upr.1ff14d28.mp3";